import api from '@/lib/api'
import deepmerge from 'deepmerge'

// eslint-disable-next-line no-unused-vars
function overwriteArray(target, source, options) {
  return source
}

const state = () => ({
  progress: null,
  unclaimedProUser: null,
})

const getters = {
  progress: state => state.progress,
  unclaimedProUser: state => state.unclaimedProUser,
}

const actions = {
  async loadUnclaimedPro({ commit }, claim_token) {
    const result = await api.insecure_get(`/claim/pro/${claim_token}`)
    if (result.ok) {
      if (result.status == 204) {
        commit('RESET_PROGRESS')
        return { ok: true, accountClaimed: true }
      }

      let unclaimedUser = await result.json()
      commit('SET_PROGRESS', {
        claim_token,
        pro_user_id: unclaimedUser.pro_user_id,

        pro_user: { name: unclaimedUser.name },
        pro: unclaimedUser.pro,
      })

      return { ok: true, accountClaimed: false, mostRecentLead: unclaimedUser.most_recent_lead }
    }

    commit('RESET_PROGRESS')
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadUnclaimedProUser({ commit }, claim_token) {
    const result = await api.insecure_get(`/claim/user/${claim_token}`)
    if (result.ok) {
      commit('SET_UNCLAIMED_PRO_USER', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateProgress( { commit, state }, changes ) {
    let newProgress = deepmerge(state.progress, changes, { arrayMerge: overwriteArray })
    commit('SET_PROGRESS', newProgress)
  },

  async claimPro({ commit, dispatch }, { claim_token, ...changes }) {
    const result = await api.post(`/claim/pro/${ claim_token }`, { claim: changes })

    if (result.ok) {
      commit('RESET_PROGRESS')
      return await dispatch('auth/updateMeHelper', await result.json(), { root: true })
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async claimUser({ commit, dispatch }, { claim_token, name, password }) {
    const result = await api.post(`/claim/user/${ claim_token }`, { claim: { name, password } })

    if (result.ok) {
      commit('SET_UNCLAIMED_PRO_USER', null)
      return await dispatch('auth/updateMeHelper', await result.json(), { root: true })
    }

    return { ...await result.json(), status: result.status, ok: false }
  }
}

const mutations = { 
  RESET_PROGRESS: (state) => state.progress = null,
  SET_PROGRESS: (state, progress) => state.progress = progress,
  SET_UNCLAIMED_PRO_USER: (state, user) => state.unclaimedProUser = user,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}